//
//
//
//

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('BaseInput', component.exports)
}
export default {
  name: "BaseInput",
}
